import React, { useState, useRef, useEffect } from 'react';
import { MdAdd, MdSettings, MdArrowDropDown, MdFilterList, MdGroup, MdSearch, MdEdit, MdVisibility, MdLocationOn, MdBusiness } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import SearchBox from './SearchBox';
import StatusUpdateModal from './StatusUpdateModal';
import AddGroupModal from './AddGroupModal';
import ViewDetailsModal from './ViewDetailsModal';
import TableLoadingWrapper from './TableLoadingWrapper';
import SearchableDropdown from './SearchableDropdown';
import axios from 'axios';
import '../styles/views.css';

const GroupsView = ({
  pagedFilteredData,
  searchTerm: groupsSearchTerm,
  setSearchTerm: setGroupsSearchTerm,
  pageCount,
  handlePageClick,
  setIsAddModalOpen,
  setEditGroup,
  setIsEditModalOpen,
  currentPage,
  totalRows,
  itemsPerPage,
  statusFilter,
  setStatusFilter,
  mmdaFilter,
  setMmdaFilter,
  mmdas,
  fetchData,
  showPopup,
}) => {
  const [openPopupIndex, setOpenPopupIndex] = useState(null);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [isAddGroupModal, setIsAddGroupModal] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [viewGroup, setViewGroup] = useState(null);
  const popupRefs = useRef({});

   // Close popup if click outside
   useEffect(() => {
     const handleClickOutside = (event) => {
      if (openPopupIndex !== null) {
        const popup = popupRefs.current[openPopupIndex];
        if (popup && !popup.contains(event.target)) {
          setOpenPopupIndex(null);
        }
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openPopupIndex]);


  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return { bg: '#e8f5e8', color: '#2e7d32' };
      case 'inactive':
        return { bg: '#ffebee', color: '#c62828' };
      default:
        return { bg: '#f5f5f5', color: '#666' };
    }
  };

  return (
    <>
      {/* Header Section */}
      <div style={{
        marginBottom: 24,
        borderRadius: 12,
        border: '1px solid #f0f0f0'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 16
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <MdGroup size={24} style={{ color: '#1976d2' }} />
            <h3 style={{ margin: 0, color: '#333', fontSize: 18, fontWeight: '600' }}>
              Groups Management
            </h3>
            <span style={{
              padding: '4px 12px',
              backgroundColor: '#e3f2fd',
              color: '#1976d2',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: '600'
            }}>
              {pagedFilteredData?.length || 0} Groups
            </span>
          </div>

 
        </div>

        {/* Search and Filter Controls */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
          <div style={{ position: 'relative', flex: '1', minWidth: 300 }}>
            <MdSearch size={20} style={{
              position: 'absolute',
              left: 12,
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#666'
            }} />
            <input
              type="text"
              placeholder="Search groups by name, zone, or status..."
              value={groupsSearchTerm}
              onChange={(e) => setGroupsSearchTerm(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px 10px 40px',
                borderRadius: 8,
                border: '1px solid #ddd',
                fontSize: 14,
                outline: 'none',
                transition: 'border-color 0.2s ease',
                boxSizing: 'border-box'
              }}
              onFocus={e => e.target.style.borderColor = '#1976d2'}
              onBlur={e => e.target.style.borderColor = '#ddd'}
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <MdFilterList size={20} style={{ color: '#666' }} />
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              style={{
                padding: '10px 12px',
                borderRadius: 8,
                border: '1px solid #ddd',
                fontSize: 14,
                outline: 'none',
                backgroundColor: '#fff',
                cursor: 'pointer',
                minWidth: 120
              }}
            >
              <option value="All">All Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          {/* MMDA Filter */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <MdBusiness size={20} style={{ color: '#666' }} />
            <SearchableDropdown
              options={[
                { value: "All", label: "All MMDAs" },
                ...(mmdas?.map((mmda) => ({ value: mmda.name, label: mmda.name })) || [])
              ]}
              value={mmdaFilter}
              onChange={setMmdaFilter}
              placeholder="All MMDAs"
            />
          </div>
        </div>
      </div>

      {/* Groups Table - MMDA Style */}
      <TableLoadingWrapper loading={false}>
        <div style={{ overflowX: 'auto' }}>
          <table>
            <thead>
              <tr>
                <th>Group Name</th>
                <th>Zone</th>
                <th>MMDA Name</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pagedFilteredData.map((row, i) => (
                <tr key={i} style={{ cursor: 'default' }}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <strong>{row.group_name}</strong>
                    </div>
                  </td>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      backgroundColor: '#e3f2fd',
                      borderRadius: 4,
                      fontSize: 12,
                      fontWeight: 'bold',
                      color: '#1976d2'
                    }}>
                      {row.zone_name}
                    </span>
                  </td>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      backgroundColor: '#f5f5f5',
                      borderRadius: 4,
                      fontSize: 12,
                      fontWeight: 'bold',
                      color: '#333'
                    }}>
                      {row.mmda_name}
                    </span>
                  </td>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      borderRadius: 4,
                      fontSize: 12,
                      fontWeight: 'bold',
                      backgroundColor: row.status === 'active' ? '#e8f5e8' : '#ffebee',
                      color: row.status === 'active' ? '#2e7d32' : '#c62828'
                    }}>
                      {(row.status || 'active').charAt(0).toUpperCase() + (row.status || 'active').slice(1)}
                    </span>
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button
                        onClick={async () => {
                          try {
                            const token = localStorage.getItem('authToken');
                            const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
                            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/zonal-groups/${row.group_id}`, config);
                            setViewGroup(response.data);
                            setIsViewModalOpen(true);
                          } catch (error) {
                            console.error('Failed to fetch group details:', error);
                            showPopup('Failed to fetch group details. Please try again.', 'error');
                          }
                        }}
                        style={{
                          padding: '6px 12px',
                          backgroundColor: '#4caf50',
                          color: 'white',
                          border: 'none',
                          borderRadius: 4,
                          cursor: 'pointer',
                          fontSize: 12,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 4
                        }}
                      >
                        <MdVisibility size={14} />
                        View
                      </button>

                      <button
                        onClick={() => {
                          setEditGroup(row);
                          setIsEditModalOpen(true);
                        }}
                        style={{
                          padding: '6px 12px',
                          backgroundColor: '#ff9800',
                          color: 'white',
                          border: 'none',
                          borderRadius: 4,
                          cursor: 'pointer',
                          fontSize: 12,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 4
                        }}
                      >
                        <MdEdit size={14} />
                        Edit
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </TableLoadingWrapper>
      {openPopupIndex !== null && (
        <div
          className="popup"
          ref={(el) => (popupRefs.current[openPopupIndex] = el)}
          style={{
            top: popupPosition.top,
            left: popupPosition.left,
            opacity: openPopupIndex !== null ? 1 : 0,
            transform: openPopupIndex !== null ? 'scale(1)' : 'scale(0.95)',
          }}
        >
          <button
            type="button"
            onClick={() => {
              setEditGroup(pagedFilteredData[openPopupIndex]);
              setIsEditModalOpen(true);
              setOpenPopupIndex(null);
            }}
          >
            Edit
          </button>
          <button
            type="button"
            onClick={() => {
              setSelectedGroup(pagedFilteredData[openPopupIndex]);
              setIsStatusModalOpen(true);
              setOpenPopupIndex(null);
            }}
          >
            Status
          </button>
        </div>
      )}
      {pageCount > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20 }}>
          <ReactPaginate
            previousLabel={'previous'}
            nextLabel={'next'}
            breakLabel={'...'}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            activeClassName={'active'}
          />
          <span style={{ marginLeft: 15, color: '#1976d2', fontSize: 16 }}>
            Rows {currentPage * itemsPerPage + pagedFilteredData.length} of {totalRows}
          </span>
        </div>
      )}
      <StatusUpdateModal
        isOpen={isStatusModalOpen}
        onClose={() => setIsStatusModalOpen(false)}
        group={selectedGroup}
        onStatusUpdate={(updatedGroup) => {
          fetchData();
          showPopup('Status updated successfully!', 'success');
        }}
      />

      {/* Add Group Modal */}
      <AddGroupModal
        isOpen={isAddGroupModal}
        onClose={() => setIsAddGroupModal(false)}
        showPopup={showPopup}
        fetchData={fetchData}
        API_BASE_URL={process.env.REACT_APP_API_BASE_URL}
        zones={[]}
      />

      {/* View Details Modal */}
      <ViewDetailsModal
        isOpen={isViewModalOpen}
        onClose={() => setIsViewModalOpen(false)}
        data={viewGroup}
        type="group"
        title="Group Details"
      />
    </>
  );
};

export default GroupsView;
